import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoice3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVoice3"><Path d="M22.25 12C19.6875 10.4625 19.6875 4.825 17.6375 4.825C15.5875 4.825 15.5875 9.95 13.025 9.95C10.4625 9.95 10.4625 1.75 7.9 1.75C5.3375 1.75 4.825 10.4625 1.75 12C4.825 13.5375 5.3375 22.25 7.9 22.25C10.4625 22.25 10.4625 14.05 13.025 14.05C15.5875 14.05 15.5875 19.175 17.6375 19.175C19.6875 19.175 19.175 13.5375 22.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconVoice3;
